import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { I18nText } from '@welldev-group/react-comp-lib';

import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

import TransactionDetails from './TransactionDetails';
import InvoiceCancelModal from './InvoiceCancelModal';
import InvoicePDF from './InvoicePDF';

const Invoice = ({ invoiceId, urls, signInRoutes, recaptchaKey, recaptchaWidgetSrc }) => {
  const [invoice, setInvoice] = useState(null);
  const [invoiceBalance, setInvoiceBalance] = useState(null);

  const fetchInvoice = async id => {
    const { data } = await httpClient.get(routes.billing.invoices.fetch({ id }));
    setInvoice(data.invoice);
    setInvoiceBalance(data.balance);
  };

  useEffect(() => {
    fetchInvoice(invoiceId);
  }, [invoiceId]);

  let title = invoiceId;
  let createdAt;
  let notification;
  let balanceChange;
  let cancelInvoiceModal;
  let reason;
  let reference;

  if (invoice) {
    title = invoice.title;
    createdAt = invoice.createdAt;
    notification =
      invoice.state === 'open' ? (
        <I18nText id={`billing.invoices.${invoice.reason ? 'booking' : 'pending'}`} />
      ) : null;
    reason = invoice.reason;
    reference = invoice.reference;
  }

  if (invoiceBalance) {
    balanceChange = {
      before: invoiceBalance.before,
      after: invoiceBalance.after,
      amount: invoice.amount,
      currency: invoiceBalance.currency,
    };
  }
  if (invoice && invoice.state === 'open' && !reason) {
    cancelInvoiceModal = <InvoiceCancelModal invoiceId={invoiceId} title={title} />;
  }

  const lineItemValue = () =>
    reason === 'subscription_charge' ? 'subscription_charge' : 'reserved';

  return (
    <TransactionDetails
      title={title}
      timestamp={createdAt}
      balanceChange={balanceChange}
      notification={notification}
      urls={urls}
      lineItem={<I18nText id={`billing.invoices.${reason ? lineItemValue() : 'top_up'}`} />}
      signInRoutes={signInRoutes}
      recaptchaKey={recaptchaKey}
      recaptchaWidgetSrc={recaptchaWidgetSrc}
      cancelInvoiceModal={cancelInvoiceModal}
      pdf={
        <div className="button button--v2">
          <InvoicePDF invoiceId={invoiceId} />
        </div>
      }
      reason={reason}
      reference={reference}
    />
  );
};

Invoice.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  urls: PropTypes.shape({
    billing: PropTypes.string.isRequired,
    transactions: PropTypes.string.isRequired,
    thisEntity: PropTypes.string.isRequired,
  }).isRequired,
  signInRoutes: PropTypes.shape({
    signInUrl: PropTypes.string.isRequired,
  }).isRequired,
  recaptchaKey: PropTypes.string.isRequired,
  recaptchaWidgetSrc: PropTypes.string.isRequired,
};

export default Invoice;
